// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"265":"636de685","333":"8f281947","453":"000ef747","735":"80227a67","845":"ab77cdea","858":"135eaf94"}[chunkId] + ".chunk.js";
};